var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticStyle:{"cursor":"pointer"},attrs:{"width":"140","height":"40"},on:{"click":_vm.draw}})
}
var staticRenderFns = []

export { render, staticRenderFns }